import { render, staticRenderFns } from "./storeAdsManage.vue?vue&type=template&id=f2e975e2&scoped=true"
import script from "./storeAdsManage.vue?vue&type=script&lang=js"
export * from "./storeAdsManage.vue?vue&type=script&lang=js"
import style0 from "./storeAdsManage.vue?vue&type=style&index=0&id=f2e975e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2e975e2",
  null
  
)

export default component.exports